import initModules from '../initModules';

class BfvSpieltag {
  constructor(options = {}) {
    this.$root = options.element;
    this.$gameList = this.$root.querySelector('.bfv-spieltag__gamelist');
    this.$dayDropdown = this.$root.querySelector('.bfv-spieltag__day-dropdown .dropdown select');
    this.apiRoute = this.$root.getAttribute('data-api-route');
  }

  init() {
    this.bindEvents();
    this.loadSpieltagFromHash();
  }

  loadNewData(gameday) {
    const apiUrl = `${this.apiRoute}/${gameday}`;
    window.location.hash = `spieltag=${gameday}`;
    window.divae.restApi
      .loadData(apiUrl, 'application/xhtml+xml')
      .then((_response) => {
        this.$gameList.innerHTML = _response;
        initModules({ rootElement: this.$gameList });
      });
  }

  bindEvents() {
    const $prevArrow = this.$root.querySelector('.bfv-spieltag__arrow-navigation--previous');
    const $nextArrow = this.$root.querySelector('.bfv-spieltag__arrow-navigation--next');

    $prevArrow.addEventListener('click', (event) => {
      this.onArrowClick(event, 'previous');
    });
    $nextArrow.addEventListener('click', (event) => {
      this.onArrowClick(event, 'next');
    });

    this.$dayDropdown.addEventListener('change', () => {
      const newGameday = this.$dayDropdown.options[this.$dayDropdown.selectedIndex].value;
      this.loadNewData(newGameday);
    });

    const $matchupList = this.$root.querySelectorAll('.bfv-matchdata-result__team');
    $matchupList.forEach(($matchup) => {
      $matchup.setAttribute('href', $matchup.parentElement.firstElementChild.href);
    });
  }

  onArrowClick(event, clickType) {
    let newIndex = 0;
    if (clickType === 'previous') {
      if (this.$dayDropdown.options[this.$dayDropdown.selectedIndex - 1]) {
        newIndex = this.$dayDropdown.selectedIndex - 1;
      } else {
        newIndex = this.$dayDropdown.options.length - 1;
      }
    } else if (clickType === 'next') {
      if (this.$dayDropdown.options[this.$dayDropdown.selectedIndex + 1]) {
        newIndex = this.$dayDropdown.selectedIndex + 1;
      } else {
        newIndex = 0;
      }
    }

    this.$dayDropdown.selectedIndex = newIndex;
    this.loadNewData(this.$dayDropdown.options[this.$dayDropdown.selectedIndex].value);
  }

  loadSpieltagFromHash() {
    if (window.location.hash && window.location.hash.indexOf('spieltag') > -1) {
      const hashData = window.location.hash.split('=');
      const spieltag = hashData[hashData.findIndex(prop => (prop.indexOf('spieltag') > -1)) + 1];
      for (let i = 0; i < this.$dayDropdown.options.length; i += 1) {
        if (this.$dayDropdown.options[i].value === spieltag) {
          this.$dayDropdown.selectedIndex = i;
          this.loadNewData(this.$dayDropdown.options[i].value);
        }
      }
    }
  }
}

export default BfvSpieltag;



// WEBPACK FOOTER //
// ./src/javascript/main/BfvSpieltag/index.js